(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/utils/make-systems-list.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/utils/make-systems-list.js'); "use strict";

let SYSTEMS;
if (svs.isServer) {
  SYSTEMS = require('../../../../../sport/systems/api').systems;
} else {
  SYSTEMS = svs.components.sport.systems.SYSTEMS;
}
const blacklistedSystemsForTipsen = ['R8-3-504', 'R9-0-1356', 'U8-3-171'];
const makeSystemsList = systemType => Object.keys(SYSTEMS).filter(k => blacklistedSystemsForTipsen.indexOf(k) === -1 && SYSTEMS[k].systemType === systemType).sort((a, b) => {
  const [aFull, aHalf, aTot] = a.match(/(\d+)/g).map(Number);
  const [bFull, bHalf, bTot] = b.match(/(\d+)/g).map(Number);
  return aFull - bFull || aHalf - bHalf || aTot - bTot;
});
if (svs.isServer) {
  module.exports = makeSystemsList;
} else {
  setGlobal('svs.components.tipsen.engine.utils.makeSystemsList', makeSystemsList);
}
 })(window);